import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { DateTime } from 'luxon';
import { FC } from 'react';

const getDateString = (iso: string) => DateTime.fromISO(iso).toFormat('yyyy/MM/dd');

const styles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		width: '100%',
	},

	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: 5,
		color: 'white',
		padding: '50 50 0 50',
		fontSize: 8,
	},
});

interface Props {
	dateOfIssue: string;
	expirationDate: string;
}

export const HeaderPDF: FC<Props> = (props) => {
	const {
		dateOfIssue, //
		expirationDate,
	} = props;

	return (
		<View style={styles.container}>
			<View style={styles.content}>
				<Text>Date of issue: {getDateString(dateOfIssue)}</Text>
				<Text>Expiration date: {getDateString(expirationDate)}</Text>
			</View>
		</View>
	);
};
